import React, { FC, ReactNode } from 'react'
import { Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

// 主役本文 (= 14/400/text.primary). MUI body2 default 相当.
// 各タブの主役 text (= 薬剤名 / SOAP body / 発話 content 等) を統一する.
// 補助情報は MetaText, section heading は SectionHeading を使う.
interface BodyTextProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export const BodyText: FC<BodyTextProps> = ({ children, sx }) => (
  <Typography
    variant="body2"
    sx={[{ color: 'text.primary' }, ...(Array.isArray(sx) ? sx : [sx])]}
  >
    {children}
  </Typography>
)
